import { AxiosError } from "axios";
import * as htmlToImage from "html-to-image";
import { throttle } from "lodash";
import React, {
  ChangeEvent,
  useEffect,
  useRef,
  useState,
  useCallback,
  useMemo,
} from "react";
import { Oval } from "react-loader-spinner";
import {
  DesignerPagePostsGridSkeleton,
  TrendsRowSkeleton,
} from "../components/DesignerPage/InstaPostSkeleton";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { v4 as uuidv4 } from "uuid";
import { getBoardsByUserId } from "../app/api/admin/board";
import {
  generatePdf,
  getBrandsData,
  getDesignerFocusPosts,
  getProducts,
} from "../app/api/designerPage";
import { getTrends, GetTrendsParams } from "../app/api/trends";
import { getProductTypes, getStylingDetails } from "../app/api/trendsFilter";
import { uploadImage } from "../app/api/upload";
import { getUserId } from "../app/api/user/user";
import { RootState } from "../app/store";
import store from "../app/store";
import {
  setRequestId,
  bumpTrendCurveRefresh,
  setPendingColorForLevel2,
} from "../app/slices/trendSlice";
import CameraIcon from "../assets/icons/CameraIcon";
import CrossIcon from "../assets/icons/CrossIcon";
import GeneratePdfIcon from "../assets/icons/DownloadSnapshotIcon";
import FallbackImage from "../assets/icons/fallback_img.svg";
import { ReactComponent as Search } from "../assets/icons/search.svg";
import CustomizedModal from "../components/Common/CustomisedModal";
import InstaPost from "../components/DesignerPage/InstaPost";
import Preferences from "../components/DesignerPage/Preferences";
import Trends from "../components/DesignerPage/Trends/Trends";
import TrendsSidebar from "../components/DesignerPage/TrendsSidebar/TrendsSidebar";
import TrendsSnapshotModal from "../components/DesignerPage/TrendsSnapshot/TrendsSnapshotModal";
import Pagination from "../components/Target/Pagination";
import {
  defaultMaterials,
  DESIGNER_PAGE_SIZE,
  mappedTrendFilterType,
  materialsForBackend,
  MAX_TRENDS_FOR_SNAPSHOT_IMAGE,
  POSTS_PER_TREND,
  stylingDetailsForBackend,
  TREND_DATE_REQUIRED,
} from "../constants/constants";
import { Board } from "../interface/BoardsInterface";
import {
  BrandItem,
  brandsParams,
  FeedItem,
  GetBrandsParams,
  GetPostParams,
} from "../interface/DesignerInterface";
import { TrendInterface } from "../interface/Trends";
import {
  areArraysEqual,
  formatNumber,
  getFileName,
  getKeyForS3DesignerPage,
  getKeyForS3PdfGeneration,
  getKeyFromValueForTrendQueryType,
} from "../utils/commonUtils";
import { generateColorAnalysisS3JSON } from "../utils/trendSidebarGraphUtils/colorAnalysisUtils";
import {
  getStoredColorForLevel2,
  getTrendFiltersFromSession,
} from "../utils/trendSidebarGraphUtils/graphHelperUtils";
import { generateOverallAnalysisS3JSON } from "../utils/trendSidebarGraphUtils/overallAnalysisUtils";
import {
  generateTrendCurvesS3JSON,
  persistTrendAnalysisParamsToSession,
} from "../utils/trendSidebarGraphUtils/trendCurvesUtils";
import {
  getTrendSessionCacheKey,
  LiveTrendsCache,
  readLiveTrendsCache,
  saveLiveTrendsCache,
} from "../utils/trendSidebarGraphUtils/liveTrendsCache";
import { useDropdownData } from "../app/hooks/DesignerPageHooks/preferencesFilterHooks";
import { queryClient } from "../app/react-query-client";
import { getReqIdAccordingToSelectedFilter } from "../utils/designerPage-utils";
import { refreshArchivedTrends } from "../utils/refreshArchivedTrends";

type Props = {
  isSidebarOpen: boolean;
  trendsOpen: boolean;
  setTrendsOpen: React.Dispatch<React.SetStateAction<boolean>>;
};

const getCachedLiveAnalysis = () => {
  const filters = getTrendFiltersFromSession();
  return filters ? readLiveTrendsCache(filters) : null;
};

const DesignerPage: React.FC<Props> = ({
  isSidebarOpen,
  trendsOpen,
  setTrendsOpen,
}) => {
  // All the state variables will be here
  const [dropdownOpen, setDropdownOpen] = useState<boolean>(false);
  const [sidebarOpen, setSidebarOpen] = useState<boolean>(false);
  const [calendarOpen, setCalendarOpen] = useState<boolean>(false);
  const [posts, setPosts] = useState<FeedItem[]>([]);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [loading, setLoading] = useState<boolean>(
    () => !getCachedLiveAnalysis()
  );
  const [loadingMore, setLoadingMore] = useState<boolean>(false);

  const imageRef = useRef<HTMLInputElement>(null);

  const dropdownRef = useRef<HTMLDivElement>(null);
  const calendarRef = useRef<HTMLDivElement>(null);
  //preferences Filters
  const [genre, setGenre] = useState<string>("");
  const [product, setProduct] = useState<string>("");
  const [gender, setGender] = useState<string>("");
  const [ageGroup, setAgeGroup] = useState<string>("");
  const [region, setRegion] = useState<string>("");
  const [category, setCategory] = useState<string>("");
  const [source, setSource] = useState<string>("");
  const [brands, setBrands] = useState<string[]>([]);
  const [startDate, setStartDate] = useState<string>("");
  const [endDate, setEndDate] = useState<string>("");
  const [color, setColor] = useState<string>("");
  //Search Queries
  const [searchQuery, setSearchQuery] = useState<string>("");
  const [searchString, setSearchString] = useState<string>("");

  const [brandsList, setBrandsList] = useState<{
    [key: string]: brandsParams[];
  }>({});
  const [productList, setProductList] = useState<string[]>([]);

  const [productType, setProductType] = useState<string[]>([]);
  const [selectedProductType, setSelectedProductType] = useState<string>("");
  const [selectedMaterial, setSelectedMaterial] = useState<string[]>([]);
  const [stylingDetails, setStylingDetails] = useState<string[]>([]);
  const [selectedStylingDetail, setSelectedStylingDetail] = useState<string[]>(
    []
  );
  const user = useSelector((state: RootState) => state.user.userInfo);

  const userEmail = user?.email;
  const userName = user?.name;
  const [userId, setUserId] = useState("");
  const [boardsList, setBoardsList] = useState<Board[]>([]);
  const [publicBoards, setPublicBoards] = useState<Board[]>([]);
  const [privateBoards, setPrivateBoards] = useState<Board[]>([]);

  const [image, setImage] = useState<string | null>(null);
  const [uploadImageUrl, setUploadImageUrl] = useState<string | null>(null);
  const [loadingImage, setLoadingImage] = useState(false);
  const [imagePreview, setImagePreview] = useState(false);
  const [filterId, setFilterId] = useState<string>("");
  const [filterName, setFilterName] = useState<string>("");
  const scrollRef = useRef<HTMLDivElement | null>(null);
  const loadingRef = useRef(false);
  const [isBrandsModalOpen, setBrandsModalOpen] = useState(false);

  const [isBarGraphDataNotAvailable, setIsBarGraphDataNotAvailable] = useState(
    () => {
      const cached = getCachedLiveAnalysis();
      return Boolean(cached && cached.trends.length === 0);
    }
  );
  const closeBrandsModal = useCallback(() => setBrandsModalOpen(false), []);

  const controllerRef = useRef<null | AbortController>(null);
  const brandsControllerRef = useRef<null | AbortController>(null);

  // Trends Analysis
  const [analysisResultSuccess, setAnalysisResultSuccess] = useState<boolean>(
    () => Boolean(getCachedLiveAnalysis())
  );
  const [trendsLoading, setTrendsLoading] = useState<boolean>(false);
  const [trends, setTrends] = useState<TrendInterface[]>(
    () => getCachedLiveAnalysis()?.trends ?? []
  );
  const [trendsPage, setTrendsPage] = useState(
    () => getCachedLiveAnalysis()?.page ?? 1
  );
  const trendsPageSize = 10;
  const trendsPagePerTrend = POSTS_PER_TREND;
  const [trendsTotalPages, setTrendsTotalPages] = useState(() => {
    const cached = getCachedLiveAnalysis();
    if (!cached) return 1;
    return Math.max(1, Math.ceil(cached.trendCount / 10));
  });
  const reqIdRef = useRef<string>(getCachedLiveAnalysis()?.reqId ?? "");
  const [clear, setClear] = useState<boolean>(false);

  const [showColorAnalysis, setShowColorAnalysis] = useState(false);
  const [colorForLevel2, setColorForLevel2] = React.useState<string>(() =>
    getStoredColorForLevel2()
  );
  const materialToSetInitially = useRef<string[]>([]);
  const stylingDetailToSetInitially = useRef<string[]>([]);
  const productTypeToSetInitially = useRef<string>("");
  const [trendFilterType, setTrendFilterType] =
    useState<string>("Most Popular");
  const [totalPostsForTrend, setTotalPostsForTrend] = useState<number>(() => {
    const cached = getCachedLiveAnalysis();
    return cached?.trends[0]?.totalPopulationCount ?? 0;
  });

  // Snapshot VAriables
  const [trendsSnapshotModal, setTrendsSnapshotModal] = useState(false);
  const [snapShotURL, setSnapShotURL] = useState<string>("");
  const snapshotRef = useRef<HTMLElement | null>(null);
  const [snapshotLoad, setSnapshotLoad] = useState<boolean>(false);
  const [reload, setReload] = useState<boolean>(false);
  const navigate = useNavigate();
  const [archivedTrendsVisible, setArchivedTrendsVisible] =
    useState<boolean>(false);
  const [lastReqId, setLastReqId] = useState<string | null>("");
  const [archiveTrendsArr, setArchiveTrendsArr] = useState<string[]>([]);
  const [lastArchiveTrends, setLastArchiveTrends] = useState<string[]>([]);
  const [snapshotInactive, setSnapshotInactive] = useState<boolean>(false);
  const [tooKsnapshot, setTookSnapshot] = useState<boolean>(false);
  const [pdfGenerating, setPdfGenerating] = useState<boolean>(false);
  const [totalBrandsCount, setTotalBrandsCount] = useState<string>("0");
  const TRENDS_PDF_DOWNLOADED_KEY = "isTrendsPdfDownloaded";

  //All the custom hooks will be here
  const {
    genres,
    regions,
    sources,
    categories,
    setGenres,
    setRegions,
    setSources,
    setCategories,
  } = useDropdownData();
  const handleSidebarToggle = useCallback(() => {
    setSidebarOpen(prev => !prev);
  }, []);
  const getUserByEmail = async () => {
    if (userEmail) {
      const res = await getUserId(userEmail);
      setUserId(res?.data?.data[0]._id);
    }
  };

  const getBoardsByUser = async () => {
    if (userId) {
      const res = await getBoardsByUserId(userId);
      setPublicBoards(res?.data?.data.public.boards);
      setPrivateBoards(res?.data?.data.private.boards);
      setBoardsList(res?.data?.data);
    }
  };

  useEffect(() => {
    getUserByEmail();
    getBoardsByUser();
  }, [userId]);
  const handleTrendsToggle = useCallback(() => {
    const hasValidCategoryAndGender =
      category &&
      gender &&
      (category === "Ethnic RTW" || category === "Western RTW");
    const hasRequiredDate =
      !TREND_DATE_REQUIRED ||
      Boolean(startDate?.trim()) ||
      Boolean(endDate?.trim());

    if (hasValidCategoryAndGender && hasRequiredDate) {
      setTrendsOpen(prev => !prev);
    } else if (!hasValidCategoryAndGender) {
      toast.warn("Please select valid category and gender", {
        hideProgressBar: true,
      });
    } else {
      toast.warn("Please select a start date or end date", {
        hideProgressBar: true,
      });
    }
  }, [category, gender, startDate, endDate, setTrendsOpen]);

  const handleClickOutside = useCallback((event: MouseEvent) => {
    if (
      dropdownRef.current &&
      !dropdownRef.current.contains(event.target as Node)
    ) {
      setDropdownOpen(false);
    }
    if (
      calendarRef.current &&
      !calendarRef.current.contains(event.target as Node)
    ) {
      setCalendarOpen(false);
    }
  }, []);

  const getProductsData = async () => {
    try {
      const response = await getProducts();
      setProductList(response);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [handleClickOutside]);

  const [isDeleteOpen, setIsDeleteOpen] = useState(false);

  const closeDeleteModal = useCallback(() => setIsDeleteOpen(false), []);

  const fetchPosts = async (page: number, query: string = "") => {
    if (scrollRef.current && page === 1) {
      scrollRef.current.scrollTop = 0;
    }

    if (controllerRef.current) {
      controllerRef.current.abort();
    }

    controllerRef.current = new AbortController();
    const { signal } = controllerRef.current;

    loadingRef.current = true;
    const pageSize = DESIGNER_PAGE_SIZE;
    const params: GetPostParams = {
      page,
      pageSize,
    };

    if (startDate) {
      params.startDate = `${startDate} 00:00:00`;
    }
    if (endDate) {
      params.endDate = `${endDate} 23:59:59`;
    }

    if (gender) params.gender = gender;
    if (ageGroup) params.ageGroup = ageGroup;
    if (genre) params.genre = genre;
    if (product) params.product = product;
    if (region) params.region = region;
    if (category) params.category = category;
    if (query) {
      params.searchQuery = searchQuery;
      if (uploadImageUrl) {
        params.s3Key = uploadImageUrl || "";
      }
    }
    if (imagePreview) {
      params.s3Key = uploadImageUrl || "";
    }
    if (brands.length > 0) params.brands = brands.join(",");
    if (source) params.source = source;
    if (color) params.colors = color.toUpperCase();

    try {
      const response = await queryClient.fetchQuery({
        queryKey: ["designerFocusPosts", params],
        queryFn: () => getDesignerFocusPosts(params, { signal }),
        staleTime: 1000 * 60 * 20,
        retry: false,
        gcTime: 1000 * 60 * 20,
        networkMode: "offlineFirst",
      });
      setTotalPages(
        Math.ceil(response.data.totalCount / response.data.pageSize)
      );
      return response?.posts;
    } catch (error) {
      if (
        (error as Error).name !== "AbortError" &&
        (error as Error).name !== "CanceledError" &&
        (error as AxiosError).response?.status !== 400
      ) {
        toast.error("Error while fetching posts", {
          hideProgressBar: true,
        });
      }
      return undefined;
    } finally {
      if (!signal.aborted) {
        loadingRef.current = false;
        setLoading(false);
      }
    }
  };

  const loadMorePosts = async (page: number) => {
    if (analysisResultSuccess || trendsLoading) return;
    setLoadingMore(true);
    try {
      const newPosts = await fetchPosts(page, searchQuery);

      if (newPosts?.length === 0 && page === 1) {
        setPosts([]);
      } else if (newPosts) {
        setPosts(prevPosts =>
          page === 1 ? [...newPosts] : [...prevPosts, ...newPosts]
        );
      }
    } finally {
      setLoadingMore(false);
    }
  };

  useEffect(() => {
    const initializePosts = async () => {
      setPosts([]);
      setLoading(true);
      setPage(1);
      const initialPosts = await fetchPosts(1, searchQuery);
      if (initialPosts) {
        setPosts(initialPosts);
      }
    };

    if (!analysisResultSuccess && !trendsLoading) {
      initializePosts();
    }

    return () => {
      if (controllerRef.current) {
        controllerRef.current.abort();
      }
    };
  }, [
    startDate,
    endDate,
    gender,
    ageGroup,
    genre,
    product,
    region,
    brands,
    source,
    color,
    category,
    searchQuery,
    imagePreview,
    analysisResultSuccess,
  ]);

  useEffect(() => {
    const params: GetBrandsParams = {};
    if (gender) params.gender = gender;
    if (ageGroup) params.ageGroup = ageGroup;
    if (genre) params.genre = genre;
    if (source) params.source = source;
    if (region) params.region = region;
    if (product) params.product = product;
    if (category) params.category = category;
    if (startDate) {
      params.startDate = `${startDate} 00:00:00`;
    }
    if (endDate) {
      params.endDate = `${endDate} 23:59:59`;
    }
    if (color) params.colors = color.toUpperCase();

    if (brandsControllerRef.current) {
      brandsControllerRef.current.abort();
    }

    brandsControllerRef.current = new AbortController();
    const { signal } = brandsControllerRef.current;
    getBrandsData(params, { signal })
      .then(res => {
        if (res.brands) {
          // if brand is selected only show post count with selected brand
          if (brands.length > 0) {
            const totalCount = Object.values(
              res.brands as Record<string, BrandItem[]>
            ).reduce((total, arr) => {
              return (
                total +
                arr.reduce((subTotal, item) => {
                  if (brands.includes(item.handle))
                    return subTotal + Number(item.count);

                  return subTotal;
                }, 0)
              );
            }, 0);
            const formattedBrands = formatNumber(totalCount);
            setTotalBrandsCount(formattedBrands);
          } else {
            // if brand is not selected show post count for all brands with filter data
            const totalCount = Object.values(
              res.brands as Record<string, BrandItem[]>
            ).reduce((total, arr) => {
              return (
                total +
                arr.reduce((subTotal, item) => subTotal + Number(item.count), 0)
              );
            }, 0);
            const formattedBrands = formatNumber(totalCount);
            setTotalBrandsCount(formattedBrands);
          }
        } else {
          setTotalBrandsCount("0");
        }
        const brandsLocal = res.brands || {};
        setBrandsList(brandsLocal);
      })
      .catch((error: AxiosError) => {
        if (error?.response?.status !== 400) {
          console.error("Error fetching brands data:", error);
        }
      });

    return () => {
      if (brandsControllerRef.current) {
        brandsControllerRef.current.abort();
      }
    };
  }, [
    gender,
    genre,
    source,
    region,
    product,
    category,
    ageGroup,
    startDate,
    endDate,
    brands,
    color,
  ]);

  useEffect(() => {
    getProductsData();
  }, []);

  const setCountFlagForArchivedTrends = async () => {
    try {
      setLoading(true);
      const { trends } = await refreshArchivedTrends(user, reqIdRef.current);
      //eslint-disable-next-line @typescript-eslint/no-explicit-any
      setArchiveTrendsArr(trends as any);
      if (trends.length > 0) {
        setArchivedTrendsVisible(true);
      } else {
        setArchivedTrendsVisible(false);
      }
    } catch (error) {
      if ((error as AxiosError)?.response?.status === 400) {
        console.error("Error fetching Archive count", error);
      }
    }
  };

  const onScrollItems = useCallback(
    throttle(() => {
      if (scrollRef.current) {
        const { scrollTop, scrollHeight, clientHeight } = scrollRef.current;

        const isNearBottom =
          Math.abs(scrollHeight - clientHeight - scrollTop) < 2000;

        if (isNearBottom && page < totalPages && !loadingRef.current) {
          loadMorePosts(page + 1);
          setPage(page + 1);
        }
      }
    }, 1000),
    [page, totalPages, loadMorePosts]
  );

  const handleSearchChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      setSearchString(e.target.value);
      if (e.target.value === "") {
        setSearchQuery("");
      }
    },
    []
  );

  const handleButtonClick = useCallback(() => {
    imageRef.current?.click?.();
  }, []);

  const handleImageUpload = useCallback(
    async (event: ChangeEvent<HTMLInputElement>) => {
      const file = event.target.files?.[0];

      if (file) {
        setLoadingImage(true);
        const fileName = getFileName(file);
        const key = getKeyForS3DesignerPage(fileName);
        const res = await uploadImage(key, file);
        setLoadingImage(false);
        setImage(`${process.env.REACT_APP_CLOUD_FRONT_URL}${res.key}`);
        setUploadImageUrl(res.key);
      }
    },
    []
  );

  const handleRemove = useCallback(() => {
    setIsDeleteOpen(true);
  }, []);

  const base64ToFile = (base64: string, filename: string): File => {
    const byteString = atob(base64.split(",")[1]);

    const mimeTypeMatch = base64.match(/:(.*?);/);
    const mimeType = mimeTypeMatch?.[1] || "image/png";

    const byteNumbers = new Array(byteString.length);
    for (let i = 0; i < byteString.length; i++) {
      byteNumbers[i] = byteString.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: mimeType });

    return new File([blob], filename, { type: mimeType });
  };

  const handlePaste = useCallback(
    async (event: React.ClipboardEvent<HTMLInputElement>) => {
      const hasImage = Array.from(event.clipboardData.items).some(item =>
        item.type.includes("image")
      );

      if (!hasImage) return;
      setLoadingImage(true);

      const items = Array.from(event.clipboardData.items);

      for (const item of items) {
        if (item?.type?.includes("image")) {
          const file = item.getAsFile();

          if (file) {
            const reader = new FileReader();

            try {
              const base64String = await new Promise<string>(
                (resolve, reject) => {
                  reader.onload = event => {
                    if (event.target && event.target.result) {
                      resolve(event.target.result as string);
                    } else {
                      reject("Failed to read the file");
                    }
                  };
                  reader.onerror = () => reject("Error reading the file");
                  reader.readAsDataURL(file);
                }
              );

              const imageFile = base64ToFile(base64String, "pasted-image.png");

              if (imageFile) {
                const fileName = getFileName(file);
                const key = getKeyForS3DesignerPage(fileName);

                const res = await uploadImage(key, imageFile);
                setImage(`${process.env.REACT_APP_CLOUD_FRONT_URL}${res.key}`);
                setUploadImageUrl(res.key);
              }
            } catch (error) {
              console.error("Image upload failed:", error);
            }

            setLoadingImage(false);
            break;
          }
        }
      }
    },
    []
  );

  useEffect(() => {
    const fetchProductTypes = async () => {
      try {
        const response = await getProductTypes({ category, gender }, user);
        setProductType(response.data);
        if (productTypeToSetInitially.current) {
          setSelectedProductType(productTypeToSetInitially.current);
          productTypeToSetInitially.current = "";
        } else {
          setSelectedProductType("");
        }
        setSelectedMaterial([]);
        setSelectedStylingDetail([]);
      } catch (error) {
        console.error("Error Fetching Product Type", error);
        if ((error as AxiosError)?.response?.status !== 400) {
          toast.error("Error Fetching Product Type", {
            hideProgressBar: true,
          });
        }
      }
    };
    if (
      category &&
      gender &&
      (category === "Ethnic RTW" || category === "Western RTW")
    ) {
      fetchProductTypes();
    } else {
      setProductType([]);
      setTrendsOpen(false);
    }
  }, [category, gender]);

  useEffect(() => {
    setSelectedStylingDetail([]);
    setSelectedMaterial([]);
    const getStylingDetail = async () => {
      try {
        const response = await getStylingDetails(
          {
            category,
            gender,
            productType: selectedProductType,
          },
          user
        );

        setStylingDetails(response.data);
        if (
          stylingDetailToSetInitially.current &&
          stylingDetailToSetInitially.current.length
        ) {
          setSelectedStylingDetail(stylingDetailToSetInitially.current);
          stylingDetailToSetInitially.current = [];
        }
        if (
          materialToSetInitially.current &&
          materialToSetInitially.current.length
        ) {
          setSelectedMaterial(materialToSetInitially.current);
          materialToSetInitially.current = [];
        }
      } catch (error) {
        console.error("Error Fetching Styling Details", error);
        if ((error as AxiosError)?.response?.status !== 400) {
          toast.error("Error Fetching Styling Details", {
            hideProgressBar: true,
          });
        }
      }
    };

    if (
      category &&
      gender &&
      selectedProductType &&
      (category === "Ethnic RTW" || category === "Western RTW")
    ) {
      getStylingDetail();
    }
  }, [selectedProductType]);

  useEffect(() => {
    if (analysisResultSuccess && reload) {
      if (trends.length === 1 && trendsPage !== 1) {
        setTrendsPage(prev => prev - 1);
      } else {
        runAnalysis(colorForLevel2, trendFilterType, trendsPage);
      }
      setReload(false);
    }
  }, [reload]);

  const snapshotDisableBtnCheck = (): boolean => {
    if (lastReqId !== reqIdRef.current) return false;

    return areArraysEqual(lastArchiveTrends, archiveTrendsArr);
  };

  const applyCachedLiveAnalysis = (cached: LiveTrendsCache) => {
    reqIdRef.current = cached.reqId;
    setTrends(cached.trends);
    setTrendsPage(cached.page);
    setTrendsTotalPages(
      Math.max(1, Math.ceil(cached.trendCount / trendsPageSize))
    );
    if (cached.trends.length === 0) {
      setIsBarGraphDataNotAvailable(true);
      setTotalPostsForTrend(0);
    } else {
      setIsBarGraphDataNotAvailable(false);
      setTotalPostsForTrend(cached.trends[0].totalPopulationCount);
    }
    setTrendsLoading(false);
    setLoading(false);
    setAnalysisResultSuccess(true);
  };

  useEffect(() => {
    setSnapshotInactive(snapshotDisableBtnCheck());
    setTookSnapshot(false);
  }, [
    tooKsnapshot,
    archiveTrendsArr,
    lastArchiveTrends,
    analysisResultSuccess,
  ]);

  useEffect(() => {
    const storedFilters = getTrendFiltersFromSession();
    if (!storedFilters) return;
    persistTrendAnalysisParamsToSession(storedFilters);
    const trendFilters = getTrendFiltersFromSession();
    if (!trendFilters) return;
    const lastReqId = sessionStorage.getItem("last_req_id");
    setLastReqId(lastReqId);
    const lastArchiveTrends = sessionStorage.getItem("last_Archive_Arr");
    setLastArchiveTrends(JSON.parse(lastArchiveTrends || "[]"));

    if (trendFilters.colorAnalysis) setShowColorAnalysis(true);
    else setShowColorAnalysis(false);
    if (trendFilters?.req_id) {
      reqIdRef.current = trendFilters.req_id;
    }
    if (trendFilters?.start_date) {
      setStartDate(
        new Date(trendFilters?.start_date + "Z").toISOString().split("T")[0]
      );
    }
    if (trendFilters?.end_date) {
      setEndDate(
        new Date(trendFilters?.end_date + "Z").toISOString().split("T")[0]
      );
    }
    if (trendFilters?.genre) {
      setGenre(trendFilters.genre);
    }
    if (trendFilters?.category) {
      setCategory(trendFilters.category);
    }
    if (trendFilters?.gender) {
      setGender(trendFilters.gender);
    }
    if (trendFilters?.region) {
      setRegion(trendFilters.region);
    }
    if (trendFilters?.product) {
      setProduct(trendFilters.product);
    }
    if (trendFilters?.age_group) {
      setAgeGroup(trendFilters.age_group);
    }
    if (trendFilters?.query_type) {
      const filterForTrend = getKeyFromValueForTrendQueryType(
        trendFilters.query_type
      );
      setTrendFilterType(filterForTrend);
    }
    const restoredColorForLevel2 = getStoredColorForLevel2();
    if (restoredColorForLevel2) {
      setColorForLevel2(restoredColorForLevel2);
    }
    setTrendsOpen(true);
    if (trendFilters?.apparel_type) {
      productTypeToSetInitially.current = trendFilters.apparel_type;
    }
    const materialsFromSession = Object.keys(materialsForBackend)
      .filter(key => {
        return trendFilters?.[key as keyof typeof materialsForBackend];
      })
      .map(
        key =>
          materialsForBackend[key as keyof typeof materialsForBackend].label
      );
    materialToSetInitially.current = materialsFromSession;
    const stylingDetailsFromSession = Object.keys(stylingDetailsForBackend)
      .filter(key => {
        return trendFilters?.[key as keyof typeof stylingDetailsForBackend];
      })
      .map(
        key =>
          stylingDetailsForBackend[key as keyof typeof stylingDetailsForBackend]
            .label
      );
    stylingDetailToSetInitially.current = stylingDetailsFromSession;
    if (trendFilters?.brands) {
      setBrands(trendFilters?.brands.split(","));
    }
    const cachedAnalysis = readLiveTrendsCache(trendFilters);
    if (cachedAnalysis) {
      applyCachedLiveAnalysis(cachedAnalysis);
      void setCountFlagForArchivedTrends();
    } else {
      runAnalysis(colorForLevel2, trendFilterType, 1, trendFilters);
    }
  }, []);

  const runAnalysis = async (
    colorForLevel2Local: string,
    overallAnalysisFilterTypeLocal: string,
    page: number,
    trendFilters?: GetTrendsParams
  ) => {
    //eslint-disable-next-line
    let response: any;

    setTrendsPage(page);

    try {
      if (controllerRef.current) {
        controllerRef.current.abort();
      }
      trends.length > 0 && setTrends([]);
      posts.length > 0 && setPosts([]);
      setTrendsLoading(true);
      setAnalysisResultSuccess(false);
      if (trendFilters) {
        const trendFiltersWithoutColor = { ...trendFilters };
        delete trendFiltersWithoutColor.colors;
        const storedReqIdParams = getReqIdAccordingToSelectedFilter(
          trendFiltersWithoutColor,
          reqIdRef
        );
        const [trendPromise, _] = await Promise.all([
          getTrends(storedReqIdParams, user),
          setCountFlagForArchivedTrends(),
        ]);
        response = trendPromise;
      } else {
        const paramsMaterials = Object.fromEntries(
          Object.entries(materialsForBackend)
            .filter(([_, material]) =>
              selectedMaterial.includes(material.label)
            )
            .map(([key, _]) => {
              return [key, true];
            })
        );

        const paramsStylingDetails = Object.fromEntries(
          Object.entries(stylingDetailsForBackend)
            .filter(([_, stylingDetail]) =>
              selectedStylingDetail.includes(stylingDetail.label)
            )
            .map(([key, _]) => {
              return [key, true];
            })
        );
        const oldReqId = reqIdRef.current;
        reqIdRef.current = reqIdRef.current || uuidv4();
        const newReqId = reqIdRef.current;

        const params: GetTrendsParams = {
          ...paramsMaterials,
          ...paramsStylingDetails,
          ...(selectedProductType
            ? {
                apparel_type: selectedProductType,
              }
            : {}),
          page: page === 0 ? 1 : page,
          ...(ageGroup ? { age_group: ageGroup } : {}),
          pageSize: trendsPageSize,
          posts_per_trend: trendsPagePerTrend,
          ...(category ? { category: category } : {}),
          gender: gender,
          genre: genre,
          ...(brands.length > 0 ? { brands: brands.join(",") } : {}),
          ...(region ? { region: region } : {}),
          ...(source ? { source: source } : {}),
          ...(product ? { product: product } : {}),
          req_id: newReqId,
          query_type: mappedTrendFilterType[overallAnalysisFilterTypeLocal],
        };
        if (colorForLevel2Local) {
          params.selected_color = colorForLevel2Local.split("#")[1];
          params.color_analysis_level = "LEVEL2";
          params.level2Color = colorForLevel2Local;
        } else if (selectedMaterial.includes("Color")) {
          params.color_analysis_level = "LEVEL1";
          delete params.selected_color;
          delete params.level2Color;
        }
        if (startDate) {
          params.start_date = `${startDate} 00:00:00`;
        }
        if (endDate) {
          params.end_date = `${endDate} 23:59:59`;
        }
        const storedReqIdParams = getReqIdAccordingToSelectedFilter(
          params,
          reqIdRef
        );
        const trendsPromise = getTrends(storedReqIdParams, user);

        const [trendsResponse, _] = await Promise.all([
          trendsPromise,
          setCountFlagForArchivedTrends(), // called in parallel
        ]);
        response = trendsResponse;

        persistTrendAnalysisParamsToSession(params);
        store.dispatch(setPendingColorForLevel2(null));

        if (oldReqId !== newReqId) {
          if (selectedMaterial.includes("Color")) setShowColorAnalysis(true);
          else setShowColorAnalysis(false);
          setSnapshotInactive(snapshotDisableBtnCheck());
          setTookSnapshot(false);
          sessionStorage.setItem(TRENDS_PDF_DOWNLOADED_KEY, "false");
        }
      }
      setTrendsTotalPages(
        Math.ceil(response?.data?.trendCount / trendsPageSize)
      );
      if (response?.data?.trends?.length === 0) {
        setIsBarGraphDataNotAvailable(true);
        setTotalPostsForTrend(0);
      } else {
        setIsBarGraphDataNotAvailable(false);
        setTotalPostsForTrend(response?.data?.trends?.[0].totalPopulationCount);
      }
      setTrends(response?.data?.trends);

      const filtersForCache = getTrendFiltersFromSession();
      if (response?.data?.trends && filtersForCache) {
        saveLiveTrendsCache({
          cacheKey: getTrendSessionCacheKey(filtersForCache),
          reqId: reqIdRef.current,
          page: page === 0 ? 1 : page,
          trends: response.data.trends,
          trendCount: response.data.trendCount ?? 0,
        });
      }

      const prevReduxReqId = store.getState().trends.trendsData?.req_id;
      store.dispatch(setRequestId(reqIdRef.current));
      // setRequestId only invalidates when req_id changes. Re-run Analysis often
      // keeps a canned req_id — refresh curves/OA on page-1 runs, not pagination.
      if ((page === 0 || page === 1) && prevReduxReqId === reqIdRef.current) {
        store.dispatch(bumpTrendCurveRefresh());
      }

      const scroller = document.querySelector(".trends-scroller");
      if (scroller) {
        scroller.scrollTop = 0;
      }
    } catch (error) {
      if ((error as AxiosError)?.response?.status !== 400) {
        if ((error as AxiosError)?.response?.status === 422) {
          toast.error(
            (error as AxiosError<{ message: string }>)?.response?.data
              .message || "Error Fetching Trends",
            {
              hideProgressBar: true,
            }
          );
        } else {
          console.error(error);
          toast.error("Error Fetching Trends", {
            hideProgressBar: true,
          });
        }
      }
    } finally {
      setTrendsLoading(false);
      setAnalysisResultSuccess(true);
    }
  };

  const handleTakeSnapshot = async (
    event: React.MouseEvent<HTMLButtonElement>
  ): Promise<void> => {
    const container = document.querySelector<HTMLElement>(".target-container");
    if (!container) {
      console.error("Container not found");
      return;
    }

    // Create a click effect
    const clickEffect = document.createElement("div");
    Object.assign(clickEffect.style, {
      position: "absolute",
      top: `${event.clientY}px`,
      left: `${event.clientX}px`,
      width: "30px", // Increased size
      height: "30px",
      background:
        "radial-gradient(circle, rgba(255,255,255,0.8) 0%, rgba(255,255,255,0) 70%)", // Gradient effect
      borderRadius: "50%",
      transform: "translate(-50%, -50%) scale(0)",
      transition: "transform 0.7s ease-out, opacity 0.7s ease-out", // Longer duration
      pointerEvents: "none",
      zIndex: "9999",
    });

    document.body.appendChild(clickEffect);

    // Trigger the animation
    setTimeout(() => {
      clickEffect.style.transform = "translate(-50%, -50%) scale(8)"; // Larger scale
      clickEffect.style.opacity = "0";
    }, 0);

    // Remove the effect after animation
    setTimeout(() => {
      document.body.removeChild(clickEffect);
    }, 1000);
    setSnapshotLoad(true);
    try {
      const dataUrl = await htmlToImage.toPng(container, {
        filter: node => {
          // Exclude elements with snapshot-excluded class
          return !node.classList?.contains("snapshot-excluded");
        },
      });

      setSnapShotURL(dataUrl);

      const tempSnapshot = document.createElement("img");
      tempSnapshot.src = dataUrl;

      Object.assign(tempSnapshot.style, {
        position: "fixed",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        width: "60vw",
        height: "75vh",
        objectFit: "cover",
        border: "5px solid #4d4d4d",
        boxShadow: "0px 4px 10px #4d4d4d",
        backgroundColor: "white",
      });

      document.body.appendChild(tempSnapshot);

      setTimeout(() => {
        document.body.removeChild(tempSnapshot);
      }, 1500);
    } catch (error) {
      //adding the fallback image
      setSnapShotURL(FallbackImage);
      console.error("Error capturing snapshot:", error);
    } finally {
      setSnapshotLoad(false);
    }
    setTimeout(() => {
      setTrendsSnapshotModal(true);
    }, 1500);
  };

  const handleGeneratePdf = async () => {
    if (pdfGenerating) return;

    const isTrendsPdfDownloaded = sessionStorage.getItem(
      TRENDS_PDF_DOWNLOADED_KEY
    );
    if (isTrendsPdfDownloaded === "true") {
      toast.success(
        "Pdf has Already been Downloaded please check notifications",
        {
          hideProgressBar: true,
        }
      );
      return;
    }

    setPdfGenerating(true);
    const toastId = toast.loading("Preparing your PDF...", {
      closeOnClick: false,
      draggable: false,
    });

    try {
      const [overallAnalysisData, colorAnalysisData, trendCurvesData] =
        await Promise.all([
          generateOverallAnalysisS3JSON(user),
          generateColorAnalysisS3JSON(user),
          generateTrendCurvesS3JSON(user),
        ]);

      if (!trendCurvesData) {
        toast.warn(
          "Trend curve could not be included in the PDF. Run trend analysis and confirm the curve chart loads in the sidebar first.",
          { hideProgressBar: true }
        );
      }

      const payloadJsonForS3 = {
        colorAnalysisData,
        overallAnalysisData,
        trendCurvesData,
      };
      const fileName = Number(new Date());
      const key = getKeyForS3PdfGeneration(userId, fileName);
      const response = await uploadImage(key, JSON.stringify(payloadJsonForS3));
      const payload = {
        from: "trend_analysis",
        userId,
        userName,
        trendRequestId: reqIdRef.current,
        filters: {
          preferences: {
            gender: gender ? gender : "None",
            source: source ? source : "None",
            "Start Date": startDate ? startDate : "None",
            "End Date": endDate ? endDate : "None",
            region: region ? region : "None",
            genre: genre ? genre : "None",
            product: product ? product : "None",
            brands: brands ? brands : [],
            category: category ? category : "None",
            color: color ? color : "None",
            "Age Group": ageGroup ? ageGroup : "None",
          },
          "trends-filters": {
            "Product Types": selectedProductType ? selectedProductType : "All",
            material: selectedMaterial.length
              ? selectedMaterial.join(",")
              : "None",
            "Styling Details": selectedStylingDetail.length
              ? selectedStylingDetail.join(",")
              : "None",
          },
        },
        graphDataJsonUrl: response.key,
      };
      await generatePdf(payload, user);
      toast.update(toastId, {
        render: "PDF is generating. You will be notified once it is done.",
        type: "success",
        isLoading: false,
        autoClose: 4000,
        hideProgressBar: true,
      });
      sessionStorage.setItem(TRENDS_PDF_DOWNLOADED_KEY, "true");
    } catch (error) {
      toast.update(toastId, {
        render: "Error generating PDF",
        type: "error",
        isLoading: false,
        autoClose: 4000,
        hideProgressBar: true,
      });
    } finally {
      setPdfGenerating(false);
    }
  };

  useEffect(() => {
    // Flatten all available brands from brandsList
    const allAvailableBrands = Object.values(brandsList)
      .flat()
      .map(b => b.handle);

    // Filter out brands that are no longer available
    if (brands.some(b => !allAvailableBrands.includes(b))) {
      setBrands(brands.filter(b => allAvailableBrands.includes(b)));
    }
  }, [brandsList]);
  return (
    <>
      <div
        className={`flex flex-col h-[calc(100vh-80px)] ${!isSidebarOpen ? "w-[calc(100vw-265px)]" : "w-[calc(100vw-105px)]"} transition-all duration-500 ease-in-out fixed ml-1  ${
          isBrandsModalOpen ? "z-10" : ""
        } target-container  align-middle whitespace-nowrap`}
      >
        <div className="flex flex-1 overflow-hidden">
          <Preferences
            startDate={startDate}
            endDate={endDate}
            isCollapsed={sidebarOpen}
            onToggle={handleSidebarToggle}
            setGenre={setGenre}
            genre={genre}
            setProduct={setProduct}
            product={product}
            setGender={setGender}
            gender={gender}
            ageGroup={ageGroup}
            setAgeGroup={setAgeGroup}
            setBrands={setBrands}
            brands={brands}
            setStartDate={setStartDate}
            setEndDate={setEndDate}
            setRegion={setRegion}
            region={region}
            genres={genres}
            regions={regions}
            sources={sources}
            source={source}
            setSource={setSource}
            brandsList={brandsList}
            productList={productList}
            color={color}
            setColor={setColor}
            categories={categories}
            category={category}
            setCategory={setCategory}
            isBrandsModalOpen={isBrandsModalOpen}
            setBrandsModalOpen={setBrandsModalOpen}
            closeBrandsModal={closeBrandsModal}
            filterId={filterId}
            filterName={filterName}
            setFilterId={setFilterId}
            setFilterName={setFilterName}
            TrendSnapshotDisabled={false}
            TrendsSnapshotPreferencesView={false}
            disableColorPicker={trendsOpen}
            setClear={setClear}
            totalBrandsCount={totalBrandsCount}
          />
          <div
            className={`${analysisResultSuccess ? "px-4" : ""} flex-1 bg-lightGray`}
          >
            <div className="flex flex-col md:flex-row justify-around items-center mb-1">
              {!analysisResultSuccess && (
                <div className="flex bg-white w-full items-center border border-black text-center justify-center rounded-lg p-1">
                  <input
                    type="text"
                    placeholder="Search"
                    className="w-full pl-3 text-md outline-none"
                    value={searchString}
                    onChange={handleSearchChange}
                    onPaste={handlePaste}
                    onKeyDown={e => {
                      if (e.key === "Enter") {
                        setSearchQuery(searchString);
                        if (uploadImageUrl && image) {
                          setImagePreview(true);
                        } else {
                          setImagePreview(false);
                        }
                      }
                    }}
                  />
                  {!image ? (
                    <>
                      {loadingImage ? (
                        <>
                          <div className="flex justify-center items-center h-full">
                            <Oval
                              height={10}
                              width={10}
                              color="black"
                              visible={true}
                              ariaLabel="oval-loading"
                              secondaryColor="black"
                              strokeWidth={2}
                              strokeWidthSecondary={2}
                            />
                          </div>
                        </>
                      ) : (
                        <div
                          onClick={handleButtonClick}
                          className="cursor-pointer"
                        >
                          <CameraIcon />
                        </div>
                      )}
                    </>
                  ) : (
                    <div className="relative">
                      <div
                        className="absolute top-[-3px] right-[-3px] bg-white w-[10px] h-[10px] rounded-xl cursor-pointer flex justify-center items-center"
                        onClick={handleRemove}
                      >
                        <CrossIcon width="6px" height="6px" />
                      </div>
                      <div>
                        <img
                          src={image || ""}
                          alt="Uploaded Preview"
                          className="object-cover w-[40px] h-[25px] rounded"
                        />
                      </div>
                    </div>
                  )}
                  <input
                    ref={imageRef}
                    hidden
                    multiple
                    id="accept-photo"
                    accept=".jpg, .jpeg, .png , .gif, .svg"
                    type="file"
                    onChange={handleImageUpload}
                  />
                  <Search
                    className="w-6 h-6 cursor-pointer ml-3 mr-1 "
                    onClick={() => {
                      setSearchQuery(searchString);
                      if (uploadImageUrl && image) {
                        setImagePreview(true);
                      } else {
                        setImagePreview(false);
                      }
                    }}
                  />
                </div>
              )}
            </div>
            {analysisResultSuccess && (
              <div className="w-full h-10 bg-white mb-2 rounded-lg flex items-center">
                <div className="flex justify-between w-full">
                  <div>
                    <button
                      className="px-3 font-bold text-xs disabled:text-gray-400"
                      // disabled={true}
                      disabled={
                        !analysisResultSuccess || !archivedTrendsVisible
                      }
                      onClick={() => navigate("/designer-page/archive")}
                    >
                      Check Archive
                    </button>
                    |
                    <button
                      className={`px-3 font-bold text-xs  disabled:text-gray-400 ${
                        snapshotLoad ? "text-gray-400 " : ""
                      }`}
                      // disabled={true}
                      disabled={
                        snapshotLoad || trends.length === 0 || snapshotInactive
                      }
                      onClick={handleTakeSnapshot}
                    >
                      {snapshotLoad ? "Taking Snapshot..." : "Take Snapshot"}
                    </button>
                  </div>
                  <div className="flex justify-center items-center">
                    <div className="text-sm mr-5">
                      Total Posts : <b>{totalPostsForTrend}</b>
                    </div>
                    <button
                      className={`mr-4 flex items-center justify-center ${
                        pdfGenerating || trends.length === 0
                          ? "cursor-not-allowed opacity-50"
                          : "cursor-pointer"
                      }`}
                      onClick={handleGeneratePdf}
                      disabled={pdfGenerating || trends.length === 0}
                      title={
                        pdfGenerating ? "Generating PDF..." : "Download PDF"
                      }
                    >
                      <GeneratePdfIcon height={24} width={24} fill="#212121" />
                    </button>
                  </div>
                </div>
              </div>
            )}
            <div
              className={` h-[calc(100vh-130px)]  overflow-auto bg-white p-2.5 rounded-lg`}
              ref={scrollRef}
              onScroll={onScrollItems}
            >
              {((!analysisResultSuccess && loading) || trendsLoading) && (
                <>
                  {trendsLoading ? (
                    <div className="space-y-4">
                      {Array.from({ length: 3 }).map((_, index) => (
                        <TrendsRowSkeleton
                          key={index}
                          trendsOpen={trendsOpen}
                        />
                      ))}
                    </div>
                  ) : (
                    <DesignerPagePostsGridSkeleton trendsOpen={trendsOpen} />
                  )}
                </>
              )}
              {analysisResultSuccess ? (
                <>
                  {trends.length > 0 ? (
                    <>
                      <div
                        className={`trends-scroller overflow-y-scroll scroller ${trendsTotalPages > 1 ? "h-[calc(100%-45px)]" : "h-full"}`}
                      >
                        {trends.map((item, index) => {
                          return (
                            <Trends
                              key={index}
                              isSidebarOpen={isSidebarOpen}
                              sidebarOpen={sidebarOpen}
                              name={item.name}
                              selection={item.trendCategory}
                              trendsOpen={trendsOpen}
                              posts={item.posts}
                              privateBoards={privateBoards}
                              setPrivateBoards={setPrivateBoards}
                              publicBoards={publicBoards}
                              setPublicBoards={setPublicBoards}
                              userId={userId}
                              req_id={reqIdRef.current}
                              trendSnapshotTrendsView={false}
                              setReload={setReload}
                              analysisResultSuccess={analysisResultSuccess}
                              bet={item.graphData.bet}
                              contribution={item.graphData.contribution}
                              impact={item.graphData.impact}
                              className={
                                index >= MAX_TRENDS_FOR_SNAPSHOT_IMAGE
                                  ? "snapshot-excluded"
                                  : ""
                              }
                              totalVisiblePostsCount={
                                item.totalVisiblePostsCount
                              }
                              postCount={item.postCount}
                            />
                          );
                        })}
                      </div>
                      <div
                        className={`mt-1 ${trendsTotalPages > 1 ? "block" : "hidden"}`}
                      >
                        <Pagination
                          currentPage={trendsPage}
                          totalPages={trendsTotalPages}
                          onPageChange={(page: number) =>
                            runAnalysis(
                              colorForLevel2 || "",
                              trendFilterType,
                              page
                            )
                          }
                        />
                      </div>
                    </>
                  ) : (
                    <div className="font-poppins text-center mt-10 w-full">
                      No Trends Found
                    </div>
                  )}
                </>
              ) : posts?.length === 0 && !loading ? (
                trendsLoading ? (
                  <></>
                ) : (
                  <div className="text-center text-gray-500">No data found</div>
                )
              ) : (
                <>
                  <div className="flex flex-wrap justify-evenly gap-4">
                    {posts.map((item, index) => {
                      return (
                        <InstaPost
                          key={`${item.postId}-${index}`}
                          item={item}
                          trendsOpen={trendsOpen}
                          privateBoards={privateBoards}
                          setPrivateBoards={setPrivateBoards}
                          publicBoards={publicBoards}
                          setPublicBoards={setPublicBoards}
                          userId={userId}
                        />
                      );
                    })}
                  </div>
                  {loadingMore && (
                    <div className="flex justify-center items-center py-8 w-full">
                      <Oval
                        height={40}
                        width={40}
                        color="black"
                        visible={true}
                        ariaLabel="oval-loading"
                        secondaryColor="gray"
                        strokeWidth={2}
                        strokeWidthSecondary={2}
                      />
                    </div>
                  )}
                </>
              )}
            </div>
          </div>
          <TrendsSidebar
            isTrendOpen={trendsOpen}
            onTrendToggle={handleTrendsToggle}
            productType={productType}
            selectedProductType={selectedProductType}
            setSelectedProductType={setSelectedProductType}
            materials={defaultMaterials}
            selectedMaterial={selectedMaterial}
            setSelectedMaterial={setSelectedMaterial}
            stylingDetails={stylingDetails}
            selectedStylingDetail={selectedStylingDetail}
            setSelectedStylingDetail={setSelectedStylingDetail}
            runAnalysis={runAnalysis}
            setAnalysisResultSuccess={setAnalysisResultSuccess}
            refChange={(value: string) => (reqIdRef.current = value)}
            startDate={startDate}
            endDate={endDate}
            region={region}
            genre={genre}
            product={product}
            gender={gender}
            brands={brands}
            source={source}
            category={category}
            color={color}
            req_id={reqIdRef.current}
            TrendsSidebarSnapshotExpandedView={false}
            ageGroup={ageGroup}
            analysisResultSuccess={analysisResultSuccess}
            clear={clear}
            setClear={setClear}
            colorForLevel2={colorForLevel2}
            setColorForLevel2={setColorForLevel2}
            showColorAnalysis={showColorAnalysis}
            trendFilterType={trendFilterType}
            setTrendFilterType={setTrendFilterType}
            isBarGraphDataNotAvailable={isBarGraphDataNotAvailable}
            setIsBarGraphDataNotAvailable={setIsBarGraphDataNotAvailable}
            trendsLoading={trendsLoading}
          />
        </div>
        {trendsSnapshotModal && (
          <TrendsSnapshotModal
            setTrendsSnapshotModal={setTrendsSnapshotModal}
            snapShotURL={snapShotURL}
            selectedMaterial={selectedMaterial}
            selectedProductType={selectedProductType}
            selectedStylingDetail={selectedStylingDetail}
            startDate={startDate}
            endDate={endDate}
            region={region}
            genre={genre}
            product={product}
            gender={gender}
            brands={brands}
            source={source}
            category={category}
            color={color}
            req_id={reqIdRef.current}
            trends={trends}
            ageGroup={ageGroup}
            setLastReqId={setLastReqId}
            setLastArchiveArr={setLastArchiveTrends}
            archiveTrendsArr={archiveTrendsArr}
            setTookSnapshot={setTookSnapshot}
            colorForLevel2={colorForLevel2}
          />
        )}
      </div>

      <CustomizedModal
        isOpen={isDeleteOpen}
        onClose={closeDeleteModal}
        title="Are you sure ?"
        width="400px"
      >
        <div className="flex justify-center space-x-8 mt-4">
          <button
            className="px-10 py-2 bg-gray-300 text-tertiary font-bold border rounded-full"
            onClick={closeDeleteModal}
          >
            Cancel
          </button>
          <button
            className="px-10 py-2 bg-black text-white font-bold rounded-full"
            onClick={() => {
              setImage("");
              setUploadImageUrl("");
              closeDeleteModal();
              setImagePreview(false);
            }}
          >
            Confirm
          </button>
        </div>
      </CustomizedModal>
    </>
  );
};

export default DesignerPage;
